<template>
  <UIInputDate
    ref="inputRef"
    v-model="modelValue"
    :container
    :size
    :readonly
    inline-popover
  />
</template>

<script setup lang="ts">
import { inject, useTemplateRef } from 'vue'

import { InputSize } from '@types'

import { UIInputDate } from '@ui/fields'

type Props = {
  readonly?: boolean
}

defineProps<Props>()

const modelValue = defineModel<any>()

defineExpose({
  start() {
    inputRef.value?.select()
  },
})

const container = inject<string>('container')
const size = inject<InputSize>('size')

const inputRef = useTemplateRef('inputRef')
</script>
